<template>
  <div class="usersExampleUser">
    <Row type="flex" justify="space-around">
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 1"
        >
          <use xlink:href="#icon-mpai-people_2"></use>
        </svg>
        <div :class="index === 1 ? 'fontStyle' : ''" @click="index = 1">
          产品运营
        </div>
      </i-col>
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 2"
        >
          <use xlink:href="#icon-mpai-people_7"></use>
        </svg>
        <div :class="index === 2 ? 'fontStyle' : ''" @click="index = 2">
          中层管理
        </div>
      </i-col>
      <i-col span="8" class="users_plane">
        <svg
          class="icon-mpai-colors users_plane_img"
          aria-hidden="true"
          @click="index = 3"
        >
          <use xlink:href="#icon-mpai-people_1"></use>
        </svg>
        <div :class="index === 3 ? 'fontStyle' : ''" @click="index = 3">
          人力资源总监
        </div>
      </i-col>
    </Row>
    <div v-if="index === 1" class="pinchedContent">
      <div class="pinchedContext">
        <row class="pinchedContext" type="flex">
          <i-col span="8" class="pinched">
            <p>
              产品运营人是与业务最贴近的人群。学习数据分析，有助于快速制定与业务增长高度相关的运营决策。虽然我也知道数据分析的重要性，但是没时间没精力去学习那么多模型算法，同时还要熟练的掌握应用，不熟练的话学了也没啥意义，要是有一款软件能解决我的麻烦就好了。
            </p>
          </i-col>
          <i-col span="16"></i-col>
        </row>
      </div>
    </div>
    <div v-else-if="index === 2" class="pinchedContent">
      <row class="pinchedContext" type="flex">
        <i-col span="7"></i-col>
        <i-col span="10" class="pinched">
          <p>
            我的文案能力、演讲能力极强，但面对每天得到的大批量从下属底层拿到的数据。想从中分析出一些价值，但是自己不会数据分析技能。想学习但是每天工作压力太大，没法抽出时间学习。唉，太难了！要是能有一个软件可以点一下直接把数据分析结果生成出来就好了。
          </p>
        </i-col>
        <i-col span="7"></i-col>
      </row>
    </div>
    <div v-else-if="index === 3" class="pinchedContent">
      <div class="pinchedContext">
        <row class="pinchedContext" type="flex">
          <i-col span="16"></i-col>
          <i-col span="8" class="pinched">
            <p>
              面对“数据元年”的现在，一个公司从前台到中台再到后台，几乎所有的职位都需要基于数据分析来进行工作.想让员工们都尽可能学习数据分析这项技能，花钱请了好几个牛人来分享也没啥效果.唉，太难了!要是有个东西可以很短时间内让员工们都掌握数据分析这项技能就好了。
            </p>
          </i-col>
        </row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 2
    };
  }
};
</script>

<style lang="less" scoped>
.fontStyle {
  color: #2d8cf0;
}
.usersExampleUser {
  padding: 10px 0;
  width: 100%;
  .users_plane {
    height: 130px;
    text-align: center;
    cursor: pointer;
    .users_plane_img {
      height: 80px;
      width: 100%;
    }
  }
}
.pinchedContent {
  display: flex;
  justify-content: center;
}
.pinchedContext {
  padding: 0 5px;
  max-width: 1500px;
}
.pinchedRight {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedRight:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 86.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedRight:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 86.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedRight > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 13.5%;
  height: 20px;
  background: #ffff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinchedleft {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinchedleft:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 13.5%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinchedleft:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 13.5%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinchedleft > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 86.5%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
.pinched {
  position: relative;
  padding: 15px 20px;
  margin: 20px 0 3em;
  text-align: center;
  color: #fff;
  background: #29abe2;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  box-shadow: 6px 6px 0 0 #bde5f6;
  text-align: left;
  text-indent: 2em;
  letter-spacing: 1px;
}
.pinched:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 50%;
  width: 100px;
  height: 20px;
  margin: 0 0 0 -50px;
  background: #29abe2;
}
.pinched:after {
  content: "";
  position: absolute;
  top: -20px;
  left: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomright: 15px;
  -webkit-border-bottom-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.pinched > :first-child:before {
  content: "";
  position: absolute;
  top: -20px;
  right: 0;
  width: 50%;
  height: 20px;
  background: #fff;
  -moz-border-radius-bottomleft: 15px;
  -webkit-border-bottom-left-radius: 15px;
  border-bottom-left-radius: 15px;
}
</style>
